import React from 'react';

const ViewEyeIcon = ({ color, size = 25 }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{height: size, width:size, borderRadius: '100%', backgroundColor: color }}
    >
      <svg
      height={size - 10}
      width={size - 10}
        fill="#ffffff"
        viewBox="0 0 24 24"
        id="b80c53a0-fbf6-4494-bbaf-81c896ec0e14"
        data-name="Livello 1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {' '}
          <title>prime</title>{' '}
          <g id="4dc291fc-8aac-47e7-9145-5c0baf1f8af9" data-name="eye">
            {' '}
            <circle cx="12" cy="11.88" r="3"></circle>{' '}
            <path d="M12,4A13,13,0,0,0,0,12a13,13,0,0,0,24,0A13,13,0,0,0,12,4Zm0,12.88a5,5,0,1,1,5-5A5,5,0,0,1,12,16.88Z"></path>{' '}
          </g>{' '}
        </g>
      </svg>
    </div>
  );
};

export default ViewEyeIcon;
